import { render, staticRenderFns } from "./CustomAddressForm.vue?vue&type=template&id=85fad810"
import script from "./CustomAddressForm.vue?vue&type=script&lang=js"
export * from "./CustomAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports